import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC7Km9w7WsJfgImuqv1Ku8r-RgZhllP2mw",
  authDomain: "get-things-done-e05f7.firebaseapp.com",
  projectId: "get-things-done-e05f7",
  storageBucket: "get-things-done-e05f7.firebasestorage.app",
  messagingSenderId: "1082722253742",
  appId: "1:1082722253742:web:25033af1fe60a4f048e63f",
  measurementId: "G-RRHRRCWLNE"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {
  console.log("Messaging not supported");
}
export { messaging, getToken, onMessage };
